module.exports = __webpack_public_path__ + "static/media/sample_report1.63fe722e.png";